const appendTagManagerScript = (ga_id: string): void => {
  const tagManagerScript: HTMLScriptElement = document.createElement('script');

  tagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${ga_id}`;
  tagManagerScript.async = true;

  tagManagerScript.onload = () => {
    console.log('Google Analytics tag manager has been loaded successfully');
    appendGTAGScript(ga_id);
  };

  tagManagerScript.onerror = () => {
    console.error('Error loading Google Analytics tag manager');
  };

  document.head.prepend(tagManagerScript);
};

const appendGTAGScript = (ga_id: string): void => {
  const gtagScript: HTMLScriptElement = document.createElement('script');
  gtagScript.type = 'text/javascript';

  gtagScript.onload = () => {
    console.log('Google Analytics gtag library has been loaded successfully');
  };

  gtagScript.onerror = () => {
    console.error('Error loading Google Analytics gtag library');
  };

  const gtagCode: Text = document.createTextNode(`
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', '${ga_id}');
  `);

  gtagScript.appendChild(gtagCode);

  document.head.append(gtagScript);
};

export const addGAScript = (ga_id: string): void => {
  if (process.env.NODE_ENV === 'production') {
    appendTagManagerScript(ga_id);
  } else {
    console.warn('Google Analytics has been disabled for development mode');
  }
};

export type ThumbAction = 'thumb_up' | 'thumb_down';

export const sendGAThumbEvent = (action: ThumbAction, faq_id: number): void => {
  if (process.env.NODE_ENV === 'production') {
    gtag('event', action, {
      event_category: 'feedback',
      event_label: `${action} faq ${faq_id}`,
      value: 1
    });
  }
};
